import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ExamResult.css';
import Footer from '../../Footer';

const ExamResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedRole, score, selectedAnswers, questions } = location.state || {};

  if (!questions || !selectedAnswers) {
    return <p>Results unavailable. Please retake the exam.</p>;
  }

  const missed = questions.filter((q, i) => selectedAnswers[i] !== q.answer);

  return (
    <>
        <div className="container">
        <h2 className='exam-result-header'>{selectedRole.charAt(0).toUpperCase() + selectedRole.slice(1)} Exam Results</h2>
        <p className='exam-result-text'>Your Score: <strong>{score}%</strong></p>

        {score >= 80 ? (
            <div className="exam-congrats">
                <h3>🎉 Congratulations!</h3>
                <p>You passed the exam with flying colors.</p>

                {selectedRole === 'applicant'
                    ? (<p>Our team will review your results and follow up shortly.</p>)
                    : (<p>Your training certificate will be available on your dashboard.</p>)
                }
                
            </div>

        ) : (
            <div>
                <h3 className='exam-missed-header'>Missed Questions</h3>
                <ul>
                    {missed.map((q, i) => (
                    <li key={i} className='exam-missed-question'>
                        <p><strong>Q:</strong> {q.question}</p>
                        <p className="highlight-red">Your answer: {selectedAnswers[questions.indexOf(q)]}</p>
                        {/* <p className="highlight-green">Correct answer: {q.answer}</p> */}
                    </li>
                    ))}
                </ul>   
                <div className='exam-retake-container'>
                    <button className="exam-button" onClick={() => navigate(`/exam/${selectedRole}?type=${selectedRole}`)}>
                        Retake Exam
                    </button>
                </div>
            </div>
        )}

        </div>
        <hr />
        <Footer />
    </>
  );
};

export default ExamResult;
